import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import swal from 'sweetalert2';
import toMarkdown from 'to-markdown';

import CommentFormComponent from './CommentFormComponent';

class CommentItemComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      replying: false,
      editing: false,
      score: props.comment.score,
    };

    this.handleDelete = this.handleDelete.bind(this);
    this.handleUndelete = this.handleUndelete.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleReply = this.handleReply.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelReply = this.handleCancelReply.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handleUpVote = this.handleUpVote.bind(this);
    this.handleDownVote = this.handleDownVote.bind(this);

    this.onReply = this.onReply.bind(this);
  }


  onReply(comment) {
    this.setState({ replying: false });
    this.props.onReply({ comment, parent_comment_id: this.props.comment.id });
  }

  handleReply(e) {
    e.preventDefault();
    this.setState({ replying: !this.state.replying, editing: false });
  }

  handleEdit(e) {
    e.preventDefault();
    this.setState({ editing: !this.state.editing, replying: false });
  }

  handleUpdate(comment) {
    this.setState({ editing: false });
    this.props.onUpdate(Object.assign({}, this.props.comment, { comment }));
  }

  handleCancelReply(e) {
    e.preventDefault();
    this.setState({ replying: false });
  }

  handleCancelEdit(e) {
    e.preventDefault();
    this.setState({ editing: false });
  }

  handleDelete(e) {
    e.preventDefault();
    swal({
      title: 'Are you sure?',
      text: 'Are you sure you want to delete this comment?',
      showCancelButton: true,
      confirmButtonColor: '#12d0fc',
    }).then(result => {
      if (result.value) {
        this.props.onDelete(this.props.comment);
      }
    });
  }

  handleUndelete(e) {
    e.preventDefault();
    this.props.onUndelete(this.props.comment);
  }

  handleDownVote(e) {
    e.preventDefault();
    this.setState({ score: this.state.score - 1 });
  }

  handleUpVote(e) {
    e.preventDefault();
    this.setState({ score: this.state.score + 1 });
  }

  render() {
    const {
      id,
      comment,
      score,
      commenting_user,
      indent_level,
      updated_at,
      url,
      is_deleted,
    } = this.props.comment;
    const { currentUser } = this.props;

    const marginLeft = `${indent_level - 1}em`;
    const indented = indent_level > 1 ? 'indented' : '';

    return (
      <div
        className={`comment ${indented}`}
        style={{ marginLeft }}
      >
        <div className="comment-header">
          {false &&
            <div className="voting">
              <button onClick={this.handleUpVote}>
                <i
                  className="fa fa-angle-up"
                  aria-hidden="true"
                />
              </button>

              <span className="score">
                {this.state.score}
              </span>

              {currentUser.is_admin &&
                <button onClick={this.handleDownVote}>
                  <i
                    className="fa fa-angle-down"
                    aria-hidden="true"
                  />
                </button>
              }
            </div>
          }

          <a href="">
            {commenting_user.username || '(username pending)'}
          </a>

          <small>
            ({moment(updated_at).fromNow()})
          </small>

          <ul className="comment-actions">
            <li>
              <a href={url}>Link</a>
            </li>
            {currentUser !== null &&
              <span>
                {!is_deleted && currentUser.id === commenting_user.id &&
                  <span>
                    <li>
                      <a href="" onClick={this.handleEdit}>Edit</a>
                    </li>
                    <li>
                      <a href="" onClick={this.handleDelete}>Delete</a>
                    </li>
                  </span>
                }
                {is_deleted && currentUser.id === commenting_user.id &&
                  <li>
                    <a href="" onClick={this.handleUndelete}>Undelete</a>
                  </li>
                }
                {is_deleted ||
                  <li>
                    <a href="" onClick={this.handleReply}>Reply</a>
                  </li>
                }
              </span>
            }
          </ul>
        </div>

        {is_deleted ?
          <div className="comment-body">
            <i>Comment removed by Author</i>
          </div>
          :
          <div
            className="comment-body"
            dangerouslySetInnerHTML={{ __html: comment }}
          />
        }

        {this.state.editing &&
          <CommentFormComponent
            onCancel={this.handleCancelEdit}
            onUpdate={this.handleUpdate}
            comment={toMarkdown(comment)}
          />
        }

        {this.state.replying &&
          <CommentFormComponent
            onSubmit={this.onReply}
            onCancel={this.handleCancelReply}
          />
        }
      </div>
    );
  }
}

CommentItemComponent.propTypes = {
  onReply: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onUndelete: PropTypes.func.isRequired,
};

export default CommentItemComponent;
